export default __webpack_public_path__ + "static/media/FOTO6.9be7b08a.jpg";